import classNames from 'classnames';
import React from 'react';

import { MQ_SMALL } from 'common/constants/MediaQueries';
import useMqState from 'common/react/hooks/useMqState';
import trans from 'common/tools/translations/trans';

import Roller from 'website/components/ui/Roller';
import { isMovie } from 'website/types';

import AffinitySuggestionsItem from './AffinitySuggestionsItem';
import { PropsFromRedux } from './LazyAffinitySuggestions';
import SpeednoterItem from './SpeednoterItem';
import styles from './styles.module.scss';

type Props = Omit<PropsFromRedux, 'user'>;

const AffinitySuggestions = ({
  suggestions = [],
  entity,
  open = false,
  closeAffinitySuggestions
}: Props) => {
  const mqState = useMqState();
  // threshold of the number of items before the start of the roller
  const lazyThreshold = mqState > MQ_SMALL ? 6 : 4;

  const suggestionsItems = suggestions.map((entity, index) => {
    return (
      <AffinitySuggestionsItem
        entity={entity}
        className="roller-item"
        key={entity.id}
        lazy={index >= lazyThreshold}
      />
    );
  });

  if (isMovie(entity)) {
    suggestionsItems.push(
      <SpeednoterItem
        key="speednoter"
        className="roller-item"
        lazy={suggestions.length >= lazyThreshold}
      />
    );
  }

  const containerClasses = classNames(styles.suggestionsContainer, {
    show: open,
    hide: !open
  });

  return (
    <div className={containerClasses}>
      <div className={classNames(styles.suggestionsTitleContainer, 'cf')}>
        <span className={styles.suggestionsTitle}>
          {entity.typename == 'Movie'
            ? trans('affinities.suggestion.movie')
            : trans('affinities.suggestion.series')}
        </span>
        <span
          className={classNames(styles.suggestionsCloseIcon, 'icon icon-cross')}
          onClick={() => {
            closeAffinitySuggestions(entity);
          }}
        />
      </div>
      <Roller className={styles.rollerSuggestions}>
        <>{suggestionsItems}</>
      </Roller>
      <div className={styles.suggestionArrow} />
    </div>
  );
};

export default AffinitySuggestions;
